import { galleryCards } from "@/mocks/homeContent";

const galleryImages = [
  "https://readdy.ai/api/search-image?query=Minimal%20still%20life%20of%20a%20smartphone%20lying%20on%20warm%20beige%20paper%20desk%20beside%20a%20dried%20olive%20branch%20and%20a%20small%20ceramic%20cup%2C%20soft%20morning%20window%20light%2C%20editorial%20lifestyle%20photography%2C%20shallow%20depth%20of%20field%2C%20muted%20earthy%20tones%2C%20generous%20empty%20space%2C%20high%20detail&width=800&height=600&seq=blackliao-gallery-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Top%20view%20minimal%20desktop%20scene%20with%20an%20open%20blank%20notebook%2C%20stacked%20archive%20cards%20and%20warm%20amber%20folders%20arranged%20on%20ivory%20paper%20surface%2C%20soft%20directional%20daylight%2C%20editorial%20still%20life%20photography%2C%20muted%20warm%20neutral%20palette%2C%20clean%20geometric%20composition%2C%20high%20detail&width=800&height=600&seq=blackliao-gallery-02&orientation=landscape",
];

export default function Gallery() {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-12 md:px-8 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.34em] text-secondary-600">Gallery · 体验图鉴</p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              两个场景，看出好用不好用
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            手机端看加载与回流，桌面端看归档与搜索。图配文，比空口讲结论直观。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {galleryCards.map((c, i) => (
            <article
              key={c.title}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <div className="h-[240px] w-full md:h-[280px]">
                <img
                  src={galleryImages[i]}
                  alt={`${c.title} 体验图鉴`}
                  title={`${c.title} 黑料网站好用吗 体验图`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-6 md:p-7">
                <p className="text-[11px] tracking-widest text-foreground-500">{c.eyebrow}</p>
                <h3 className="mt-3 font-heading text-xl font-semibold text-foreground-950">{c.title}</h3>
                <ul className="mt-5 space-y-2.5">
                  {c.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-600">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-accent-500" />
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}